
export default {
  props: {
    contacts: {
      type: Array,
      default: () => [],
    },
  },
};
